import {Autocomplete, Stack, TextField} from "@mui/material";
import {useAtom} from "jotai";
import {useTranslation} from "react-i18next";
import {selectedFieldChartsAtom} from "../../store/selectedFieldChartsStore";
import {CHARTS, CHARTS_MAP} from "../../utils/chartUtils";

export const ChartSearchCard: React.FC = () => {
    const {t} = useTranslation();
    const [selectedFieldCharts, setSelectedFieldCharts] = useAtom(selectedFieldChartsAtom);
    const selectedOption = selectedFieldCharts.map((v) => CHARTS_MAP[v] ?? null).filter((v) => v);

    return (
        <Stack
            direction="column"
            alignItems="center"
            bgcolor="#F3F5FA"
            padding="1.5rem"
            border={1}
            borderColor="#E9EBF1 !important"
            minWidth="15rem"
            gap="1.25rem"
            flex="1"
        >
            <Autocomplete
                multiple
                fullWidth
                options={CHARTS}
                autoComplete={true}
                autoHighlight={true}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="filled"
                        hiddenLabel
                        margin="none"
                        size="small"
                        type="text"
                        placeholder={t("insights.chart_search_card.text_field_placeholder")}
                        fullWidth
                        InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                        }}
                    />
                )}
                value={selectedOption}
                onChange={(_, newValue) => {
                    setSelectedFieldCharts(newValue.map((item) => item.id));
                }}
            />
        </Stack>
    );
};
